import type { ComponentPropsWithoutRef, ElementType } from 'react';
import { cn } from '@/lib/cn';

type CarouselSlideProps<T extends ElementType = 'div'> = {
    as?: T;
} & ComponentPropsWithoutRef<T>;

export function CarouselSlide<T extends ElementType = 'div'>({ as, className, children, ...props }: CarouselSlideProps<T>) {
    const Component = as || 'div';
    return (
        <Component className={cn(className, 'grow-0 shrink-0 select-none mr-(--carousel-spacing)')} {...props}>
            {children}
        </Component>
    );
}
